import React from 'react';
import moment from 'moment';

import { Table, Empty, Button, Input, Checkbox, Form, Tooltip, DatePicker, Icon,Select } from 'antd';
import { FORMAT_2DECIMALS, FORMAT_3DECIMALS, FORMAT_5DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';
import { LOGISTICA_PRODUCTOS_CON_LOTE, SERIE_POR_PRODUCTO } from '../../../../common/types/parametroType'
import global from '../../../../common/utility/global';
import auth from '../../../../common/utility/auth';
import Series from "./Series";
const { Option } = Select;

export default function Productos(props) {
    const seriePorProducto = auth.user().parametros.filter(m => m.abreviatura === SERIE_POR_PRODUCTO)[0].valor === "1" ? true : false;
    const mostrarLoteProducto = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;
    const mostrarSaniProd = mostrarLoteProducto;
    var flagPrecioIncluyeIGV = props.onGetFieldValue("flagPrecioIncluyeIGV");


    return (
        <div>
            <Table
                className={'table-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                //  onExpand={async (expanded, record) => {
                //                   await props.onAgregarSerie(expanded, record);
                //                }}
                //                expandedRowRender={(record) => {
                //                    return (
                //                        <div>
                //                            {
                //                                <Series
                //                                    onGetFieldDecorator={props.onGetFieldDecorator}
                //                                    dataSource={record.listaCompraDetalleSerie}                                                  
                //                                />
                //                            }
                //                        </div>
                //                    )
                //                }}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 40,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(row)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        key: 'asignar-serie-button',
                        align: 'center',
                        width: (seriePorProducto) ? 90 : 0,
                        fixed: 'left',
                        render: (value, row) => (

                            <span>
                                <div className="custom-options" hidden={seriePorProducto ? false : true}>
                                    <Tooltip placement="top" title="Asignar Serie">
                                        <Button
                                            type="primary"
                                            icon="bars"
                                            size={"small"}
                                            disabled={row.flagAplicarSerie ? false : true}
                                            onClick={() => props.onAgregarSerie(row, props.onCalculateDetail, props.onSetFieldsValue, props.onGetFieldValue)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },


                    {
                        title: 'Código',
                        dataIndex: 'codigo',
                        key: 'codigo',
                        align: 'center',
                        width: 65,
                        ellipsis: true,
                        fixed: 'left',
                    },
                    {
                        title: 'Nombre',
                        dataIndex: 'nombre',
                        key: 'nombre',
                        width: 120,
                        fixed: 'left',
                        render: (value, row) => {
                            return (
                                <div
                                    onClick={() => props.onEditarNombreProducto(row, props.onSetFieldsValue, props.onGetFieldValue)}
                                >
                                    {props.onGetFieldDecorator(`arrNombre[${row.identifier}]`, { initialValue: value })(
                                        <Input
                                            readOnly
                                            title={props.onGetFieldValue(`arrNombre[${row.identifier}]`)}
                                            style={{ cursor: 'pointer', border: '1px solid #ffffff' }}

                                        />
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: (seriePorProducto) ? 'Series' : '',
                        dataIndex: 'detalleSeries',
                        key: 'detalleSeries',
                        width: (seriePorProducto) ? 90 : 0,
                        ellipsis: true,
                        render: (value, row) => {
                            return (
                                <div className={row.flagAplicarSerie ? '' : 'hide'}
                                    onClick={() => props.onAgregarSerie(row, props.onCalculateDetail, props.onSetFieldsValue, props.onGetFieldValue)}
                                >
                                    {props.onGetFieldDecorator(`arrDetalleSeries[${row.identifier}]`, { initialValue: value })(
                                        <Input
                                            readOnly
                                            title={props.onGetFieldValue(`arrDetalleSeries[${row.identifier}]`)}
                                            style={{ cursor: 'pointer', border: '1px solid #ffffff' }}

                                        />
                                    )}
                                </div>
                            );
                        }
                    },
                    // {
                    //     title: (seriePorProducto) ? 'Series' : '',
                    //     dataIndex: 'detalleSeries',
                    //     width: (seriePorProducto) ? 90 : 0,
                    //     key: 'detalleSeries',
                    //     ellipsis: true
                    // },
                    {
                        title: 'Unidad Medida',
                        dataIndex: 'nombreUnidadMedida',
                        key: 'nombreUnidadMedida',
                        width: 100,
                        ellipsis: true
                    },


                    {
                        title: 'Tipo IGV',
                        dataIndex: 'idImpuesto',
                        key: 'idImpuesto',
                        width: 220,
                        ellipsis: true,
                        render: (value, row, index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arridImpuesto[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(

                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo IGV"}
                                            optionFilterProp="children"
                                            onChange={(option) => { props.onCalculateDetail(row, "arridImpuesto", option.key, 0, index); }}
                                        >
                                            {props.tipoAfectacion.map(item => (
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: '',//ISC
                        dataIndex: 'flagAplicarSerie',
                        key: 'flagAplicarSerie',
                        align: 'center',
                        render: (value, row) => {
                            return (
                                <div className="hide">
                                    {props.onGetFieldDecorator(`arrFlagAplicarSerie[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input />
                                    )}
                                </div>
                            );
                        }
                    },
                    {
                        title: 'Lote',
                        width: 110,
                        dataIndex: 'numeroLote',
                        key: 'numeroLote',
                        className: mostrarLoteProducto ? 'show' : 'hide',
                        align: 'center',
                        render: (value, row) => {
                            return (
                                <Form.Item className={mostrarLoteProducto ? 'show' : 'hide'}>
                                    {props.onGetFieldDecorator(`arrLote[${row.identifier}]`, {
                                        initialValue: value
                                    })(
                                        <Input
                                            placeholder="Lote"
                                            autoComplete="off"
                                            className="text-left"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrLote", e.target.value, 0)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: 'Nro. Registro Sanitario',
                        width: 120,
                        dataIndex: 'numeroRegistroSanitario',
                        key: 'numeroRegistroSanitario',
                        className: mostrarSaniProd ? 'show' : 'hide',

                        align: 'center',
                        render: (value, row) => {
                            return (
                                <Form.Item className={mostrarSaniProd ? 'show' : 'hide'}>
                                    {props.onGetFieldDecorator(`arrNumeroRegistroSanitario[${row.identifier}]`, {
                                        initialValue: value
                                    })(
                                        <Input
                                            placeholder="Nro. Registro Sanitario"
                                            autoComplete="off"
                                            className="text-left"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrNumeroRegistroSanitario", e.target.value)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: 'Fecha Vencimiento',
                        width: 150,
                        dataIndex: 'fechaVencimientoStr',
                        key: 'fechaVencimientoStr',
                        className: mostrarLoteProducto ? 'show' : 'hide',
                        align: 'center',
                        render: (value, row) => {
                            return (
                                <Form.Item className={mostrarLoteProducto ? 'show' : 'hide'}>
                                    {props.onGetFieldDecorator(`arrFechaVencimiento[${row.identifier}]`, {
                                        initialValue: value == null ? null : moment(value, 'DD/MM/YYYY'),
                                        rules: [{
                                            required: row.flagVencimiento,
                                            message: "Formato (dd/mm/yyyy)"
                                        }]
                                    })(
                                        <DatePicker
                                            className="first-input"
                                            style={{ border: '1px solid #d9d9d9' }}
                                            placeholder="dd/mm/yyyy"
                                            disabled={row.flagVencimiento ? false : true}
                                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            format="DD/MM/YYYY"
                                            onChange={(_, value) =>
                                                props.onCalculateDetail(row, "arrFechaVencimiento", moment(value, 'DD/MM/YYYY'))
                                            }
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Valor Unitario',
                        dataIndex: 'precioUnitarioSinIGV',
                        key: 'precioUnitarioSinIGV',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrValorUnitario[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(5),
                                        rules: [{
                                            required: flagPrecioIncluyeIGV ? false : true,
                                            pattern: new RegExp(FORMAT_5DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="V. Unitario"
                                            autoComplete="off"
                                            disabled={flagPrecioIncluyeIGV ? true : false}
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => props.onCalculateDetail(row, "arrValorUnitario", e.target.value, 5)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Precio Unitario',
                        dataIndex: 'precioUnitario',
                        key: 'precioUnitario',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPrecioUnitario[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(5),
                                        rules: [{
                                            required: flagPrecioIncluyeIGV ? true : false,
                                            pattern: new RegExp(FORMAT_5DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="P. Unitario"
                                            autoComplete="off"
                                            className="text-right"
                                            disabled={flagPrecioIncluyeIGV ? false : true}
                                            onKeyPress={global.onKeyPressDecimals}
                                            onBlur={(e) => props.onCalculateDetail(row, "arrPrecioUnitario", e.target.value, 5)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrCantidad[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(3),
                                        rules: [
                                            {
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato (0.00)"
                                            },
                                            {
                                                required: true,
                                                pattern: new RegExp(GREATER_THAN_ZERO),
                                                message: ""
                                            }
                                        ]
                                    })(
                                        <Input
                                            onKeyPress={global.onKeyPressDecimals}
                                            disabled={row.flagAplicarSerie ? true : false}
                                            placeholder="Cantidad"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrCantidad", e.target.value, 3)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Total Detalle',
                        dataIndex: 'totalDetalle',
                        key: 'totalDetalle',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrTotalDetalle[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'Porcentaje Descuento',
                        dataIndex: 'porcentajeDescuento',
                        key: 'porcentajeDescuento',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPorcentajeDescuento[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            onKeyPress={global.onKeyPressDecimals}
                                            disabled={props.onGetFieldValue(`arrFlagGratuito[${row.identifier}]`)}
                                            placeholder="% Desc."
                                            autoComplete="off"
                                            className="text-right"
                                            readOnly
                                            onBlur={(e) => props.onCalculateDetail(row, "arrPorcentajeDescuento", e.target.value, 2)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Importe Descuento',
                        dataIndex: 'importeDescuento',
                        key: 'importeDescuento',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrImporteDescuento[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            onKeyPress={global.onKeyPressDecimals}
                                            disabled={props.onGetFieldValue(`arrFlagGratuito[${row.identifier}]`)}
                                            placeholder="Imp. Desc."
                                            autoComplete="off"
                                            className="text-right"
                                            readOnly
                                            onBlur={(e) => props.onCalculateDetail(row, "arrImporteDescuento", e.target.value, 2)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Sub Total',
                        dataIndex: 'subTotal',
                        key: 'subTotal',
                        align: 'center',
                        width: 90,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrSubTotal[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'IGV',
                        dataIndex: 'igv',
                        key: 'igv',
                        align: 'center',
                        width: 80,
                        render: (value, row) => (
                            <div>
                                {
                                    props.onGetFieldDecorator(`arrIgv[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2)
                                    })(
                                        <Input
                                            disabled
                                            autoComplete="off"
                                            className="text-right"
                                        />
                                    )
                                }
                            </div>
                        )
                    },
                    {
                        title: 'Total',
                        dataIndex: 'total',
                        key: 'total',
                        fixed: 'right',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrTotal[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        }]
                                    })(
                                        <Input
                                            onKeyPress={global.onKeyPressDecimals}
                                            // disabled={props.totalDisabled}
                                            disabled={true}
                                            placeholder="Total"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row, "arrTotal", e.target.value, 2)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                ]}
            >
            </Table>
        </div >
    );
}